import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import eaten404 from '../assets/eaten404.svg'; // adjust path if needed

const ErrorPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      {/* Main Content */}
      <Container
        maxWidth="sm"
        sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            py: 1,          // 🔽 reduced from 6
        }}
        >

        <Typography
            variant="h1"
            fontWeight={400}
            sx={{
                color: '#1a7f3a',
                fontSize: { xs: '4.5rem', sm: '6rem', md: '7rem' },
                lineHeight: 1,
                mb: 1,
            }}
            >
            404...!
            </Typography>


        <Box
          component="img"
          src={eaten404}
          alt="Page not found"
          sx={{
            width: '100%',
            maxWidth: 620,
            mb: 3,
          }}
        />

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Oops! The page you’re looking for has been eaten.
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/')}
          sx={{
            bgcolor: '#1a7f3a',
            textTransform: 'none',
            fontWeight: 600,
            px: 4,
            '&:hover': {
              bgcolor: '#0f5328',
            },
          }}
        >
          Go Home
        </Button>
      </Container>

      {/* Footer */}
      <Box
        sx={{
          textAlign: 'center',
          py: 2,
          borderTop: '1px solid #E5E7EB',
        }}
      >
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} SeekDeals. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default ErrorPage;
